import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ProfilePasswordComponent} from './profile-password/profile-password.component';
import {ProfileListComponent} from './profile-list/profile-list.component';


export const profileRoutes: Routes = [
  {
    path: 'profile',
    data: {
      'expectedRoles': ['Admin', 'IT', 'Accountant', 'Accountant Admin', 'UIH', 'Operation']
    },
    children: [
      {
        path: 'password',
        component: ProfilePasswordComponent,
        data: {
          'expectedRoles': ['Admin', 'IT', 'Accountant', 'Accountant Admin', 'UIH', 'Operation']
        },
      },
      {
        path: 'list',
        component: ProfileListComponent,
        data: {
          'expectedRoles': ['Admin', 'IT']
        },
      }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(profileRoutes)],
  exports: [RouterModule]
})
export class ProfileRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-routing.module.ts